<div data-toggle="popover"
  data-placement="bottom"
  i18n-title="@@app.notifications"
  title="Notifications"
  data-html="true">
  <div class="cursor-pointer notification-icon-container position-relative">
    <i #notificationIcon class="notification-icon font-size-24 font-weight-semibold se-icon p-0 text-color-white no-select">notification_on</i>
    @if (notifications?.length; as notificationsNumber) {
      <div class="position-absolute bg-red font-weight-semibold display-flex justify-content-center text-color-white cursor-pointer notification-beige">
        {{notificationsNumber}}
      </div>
    }
  </div>
  <div class="d-none">
    <div
      appClickOutside
      (clickOutside)="clickOutsideOfNotifications()"
      #notificationsContent>
      <app-ui-notifications
        [notifications]="notifications"
        (removeNotification)="removeFromNotifications($event)"
        (clearNotifications)="clearAllNotifications()"
      ></app-ui-notifications>
    </div>
  </div>
</div>
